import {
    instance as axios,
    setJwtToken,
} from "../../config/axiosInstance";

/**
 * Purchase Analytics Service
 * Handles purchase analytics API calls
 */
class PurchaseAnalyticsService {
    /**
     * Get purchase analytics - groups users by purchase count
     * @param {Object} params - Query parameters (startDate, endDate)
     * @returns {Promise<Object>} Purchase analytics data
     */
    static async getPurchaseAnalytics(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.startDate) queryParams.append('startDate', params.startDate);
            if (params.endDate) queryParams.append('endDate', params.endDate);
            
            const endPoint = `/admin/user-insights/purchase-analytics${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await axios.get(endPoint, setJwtToken());
            
            if (response.data.success) {
                return response.data.result;
            }
            throw new Error(response.data.message || 'Failed to fetch purchase analytics');
        } catch (error) {
            console.error('Error fetching purchase analytics:', error);
            throw error;
        }
    }

    /**
     * Get users by purchase count
     * @param {Object} params - Query parameters (purchaseCount, page, pageSize, startDate, endDate)
     * @returns {Promise<Object>} Users list with pagination
     */
    static async getUsersByPurchaseCount(params) {
        try {
            const { purchaseCount, page = 0, pageSize = 50, startDate, endDate, search } = params;
            
            if (!purchaseCount) {
                throw new Error('purchaseCount is required');
            }

            const queryParams = new URLSearchParams();
            queryParams.append('purchaseCount', purchaseCount);
            queryParams.append('page', page);
            queryParams.append('pageSize', pageSize);
            if (startDate) queryParams.append('startDate', startDate);
            if (endDate) queryParams.append('endDate', endDate);
            if (search) queryParams.append('search', search);
            
            const endPoint = `/admin/user-insights/users-by-purchase-count?${queryParams.toString()}`;
            const response = await axios.get(endPoint, setJwtToken());
            
            if (response.data.success) {
                return response.data.result;
            }
            throw new Error(response.data.message || 'Failed to fetch users');
        } catch (error) {
            console.error('Error fetching users by purchase count:', error);
            throw error;
        }
    }
}

export default PurchaseAnalyticsService;

